import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, Container } from 'semantic-ui-react';

const Header = () => (
	<Container>
		<Menu secondary pointing size="huge" stackable>
				<Menu.Item as={NavLink} to="/" >The Roseland Institute</Menu.Item>
				<Menu.Menu position="right">
					<Menu.Item as={NavLink} to="/publications" >Lyfrow Trelyspen Publications</Menu.Item>
					<Menu.Item as={NavLink} to="/cornishbanner" >The Cornish Banner</Menu.Item>
					<Menu.Item as={NavLink} to="/contact" >Contact</Menu.Item>
				</Menu.Menu>
		</Menu>
	</Container>
)

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js